import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ApiService } from '../../../Core/services/api.service';
import { ToastService } from '../../../Core/services/toast.service';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from '../../../Core/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-otp',
  imports: [ FormsModule, CommonModule, ReactiveFormsModule, ModalModule],
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.scss'
})
export class OtpComponent implements  OnInit, OnDestroy {
  disableButton: boolean;
  timerMessage: any;
  timerInterval: any;
  userData: any;
  otpRequested: boolean;
  otpVerified: boolean;
  otpSubmitted: boolean;
  seconds: number;
  minutes: number;
  constructor(private fb: FormBuilder, private modalService: BsModalService, private apiService: ApiService, private toastService : ToastService, private authService : AuthenticationService, private router : Router) {
    this.otpForm = this.fb.group({
      otps: this.fb.array([
        this.fb.control(null, Validators.required),
        this.fb.control(null, Validators.required),
        this.fb.control(null, Validators.required),
        this.fb.control(null, Validators.required),
        this.fb.control(null, Validators.required),
        this.fb.control(null, Validators.required),
      ]),
    });
  }
  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
    this.dis()
  }
  @ViewChild('otpModal') otpModal!: TemplateRef<any>;
  otpForm: FormGroup;
  modalRef?: BsModalRef;

  get otps(): FormArray {
    return this.otpForm.get('otps') as FormArray;
  }

  ngOnInit() {
    // this.getOtp()
    this.userData = this.authService.getData();
  }

  onKeyPress(event: KeyboardEvent, allowSpace?: boolean) {
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode != 32 || !allowSpace)) {
      event?.preventDefault();
    }
  }

  dis() {
    this.modalService?.hide();
  }

  onPaste(event: ClipboardEvent, index: number): void {
    event.preventDefault();

    // Get pasted data
    const pastedData = event.clipboardData?.getData('text') || '';

    // Remove all non-numeric characters
    const numericValue = pastedData.replace(/\D/g, '');

    // Check if pasted data has exactly 6 digits
    if (numericValue.length === 6) {
      // Split and assign to each input
      for (let i = 0; i < 6; i++) {
        this.otps.at(i).setValue(numericValue[i]);
      }

      // Focus the last input
      const lastInput = document.querySelector(`input[formControlName="otp-5"]`) as HTMLInputElement;
      lastInput?.focus();
    } else if (numericValue.length > 0) {
      // If less than 6 digits, fill from current position
      const availableSlots = 6 - index;
      const digitsToFill = Math.min(numericValue.length, availableSlots);

      for (let i = 0; i < digitsToFill; i++) {
        this.otps.at(index + i).setValue(numericValue[i]);
      }

      // Focus next empty input or last input
      const nextIndex = Math.min(index + digitsToFill, 5);
      const nextInput = document.querySelector(`input[formControlName="otp-${nextIndex}"]`) as HTMLInputElement;
      nextInput?.focus();
    }
  }

  onlyNumbers(event: any, paste?:boolean): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow: backspace, delete, tab, escape, enter
    // Only allow numbers
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  getOtp() {
    this.apiService.getOtp().subscribe((res:any) => {
      this.otpRequested = true;
        if (res.status) {
          // this.openModal();
          this.disableButton = true;
          this.seconds = 59
          this.minutes = 4
          clearInterval(this.timerInterval);
          this.timerInterval = setInterval(() => {
            if (this.seconds === 0) {
              if(this.disableButton) {
                this.disableButton = false;
                this.timerMessage = '';
              }
              if (this.minutes === 0) {
                clearInterval(this.timerInterval);
              } else {
                this.minutes--;
                this.seconds = 59;
              }
            } else {
              this.seconds--;
              if(this.disableButton) this.timerMessage = this.seconds
            }
          }, 1000);
          // clearInterval(this.timerInterval);
          // this.timerInterval = setInterval(() => {
          //   secondsRemaining--;
          //   this.timerMessage = secondsRemaining - 240;
          //   if (secondsRemaining - 240 <= 0) {
          //     clearInterval(this.timerInterval);
          //     this.timerMessage = '';
          //     this.disableButton = false;
          //   }
          //   if (secondsRemaining <= 0) {
          //     clearInterval(this.timerInterval);
          //     this.timerMessage = '';
          //     this.disableButton = false;
          //   }
          // }, 1000);
        } else {
          this.toastService.showError('Error', res.message);
        }
      },
      (err: any) => {
        this.toastService.showError('Error', err.message);
      }
    );
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (event.key === 'Delete' || event.key === 'Backspace') {
      if (index > 0) {
        if (inputValue.length === 1)
          this.otpForm.controls['otps']['controls'][index].setValue('');
        else this.focusNext(index - 1);
      }
    }
  }

  focusNext(index: number): void {
    if (index < this.otpForm.value.otps.length) {
      const nextInput = document.getElementById(
        `otpInput${index}`
      ) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  onInput(event: any, index: number): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length === 1) this.focusNext(index + 1);
  }


  verifyOtp() {
    let otp = ''
    this.otpForm.value.otps.forEach((element: any) => {
      otp += element
    });
    this.apiService.verifyOtp(otp).subscribe((res:any) => {
        this.otpSubmitted = true
        if (res.status) {
          this.otpVerified = true
          this.toastService.showSuccess('Success', res.message);
          sessionStorage.setItem('accessToken', res.data);
          setTimeout(() => this.modalService.hide(), 200);
        } else {
          this.toastService.showError('Error', 'OTP verification failed.');
          this.otpForm.controls['otps'].reset();
        }
      },
      (err: any) => {
        this.toastService.showError('Error', 'OTP verification failed.');
        this.otpForm.controls['otps'].reset();
      }
    );
  }
}

